import React, { Component } from "react";

import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

export class SplashScreen extends Component {
  render() {
    return (
      <div className="thermocycler-splash-inner" style={{
        backgroundImage:
          "url('" + window.location.origin + "/images/thermocycler-splash.svg'), linear-gradient(180deg, "+colors.blue1+" 0%, "+colors.navy1+" 100%)"
      }}>
        <div className="splash-content">
          <div className="splash-cta">
            <h2>Welcome</h2>
            <div className="button-row">
              <button
                onClick={() => {
                  this.props.setSection({
                    id: this.props.id,
                    section: "PROGRAM_OVERVIEW"
                  })
                  if(this.props.running){
                    this.props.setInnerSection({
                      id: this.props.id,
                      innerSection: "RUN_TABLE"
                    })
                  }
              }}
                disabled={!(this.props.sequence.length > 0)}
                className="secondary"
              >
                {(this.props.running)?"Currently running":"Saved protocol"}
              </button>
              <button
                onClick={() => {
                  this.props.eraseSequence({
                    id: this.props.id
                  })
                  this.props.setCurrentTime({
                    id: this.props.id,
                    currentTime: 0
                  })
                  this.props.setTotalTime({
                    id: this.props.id,
                    totalTime: "00:00"
                  })
                  this.props.setDurations({
                    id: this.props.id,
                    durations: []
                  })
                  this.props.setTotalElapsedTime({
                    id: this.props.id,
                    totalElapsedTime: 0
                  })

                  this.props.setSection({
                    id: this.props.id,
                    section: "PROGRAM_OVERVIEW"
                  })

              }}
                className="primary"
              >
                Program a new protocol
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
